import React from "react";
import {IProtocol} from "@/protocols/types/protocol";
import {ICompany} from "@/common/types";
import {Box} from "@mantine/core";

interface IFrameChartProps {
    activeCompany: ICompany;
    selectedProtocol: IProtocol | undefined;
    chart_name?: string
}

export const IFrameChart: React.FC<IFrameChartProps> = ({activeCompany, selectedProtocol, chart_name}) => {
    const url = `${window.BIOS.research_base_url}/?chart_name=${chart_name}&company_id=${activeCompany.id}&subject_id=${selectedProtocol?.subjectId}&protocol_id=${selectedProtocol?.id}`
    return (
        <Box style={{width: '100%', height: '100%', border:"none"}}>
            <iframe src={url} width={"100%"} height={"100%"} style={{border:"none"}}/>
        </Box>
    )
}